export default "__VITE_ASSET__C_MQjaL7__"